export default class AxiosHelper {
    static call_export(_url, _url_monitor,_filename, _form, _payload = {}) {
        let payload = {..._payload};
        
        if (_form != null) {
            const formData = new FormData(_form[0]);
            formData.forEach((value, key) => {
                if (key !== 'columnNameOption[]') {
                    payload[key] = value;
                }
            });
        }

        payload['columnNameOption'] = $('.columnNameOption').val();
        payload['file_name'] = _filename;
        if (!('is_zip' in payload)) {
            payload['is_zip'] = null;
        }
        var _this_helper = this;
        _this_helper.export(_url, payload, function (error, response) {
            if(error) {
                toastr.error(error.response.data.message, null, {timeOut: 3000, progressBar: true});
                return;
            }
            if(response.status) {
                _this_helper.monitor_export(_url_monitor, response.data.batch_id, payload['file_name'], payload['is_zip'] );
            } 
        });
    } 
    
    static  export(_url, _plain_object, callback = null) {
        axios.get(_url, {params: _plain_object, responseType: JSON})
             .then(response => {
                if(typeof callback === 'function') {
                    if(!response.data.status) {
                        toastr.error(response.data.message, null, {timeOut: 3000, progressBar: true});
                    }
                    callback(null, response.data);
                }
             })
             .catch(error => {
                if (typeof callback === 'function') {
                    callback(error, null);
                }
             });
    }

    static monitor_export(_url, _batch_id, _filename, _is_zip) {
        toastr.options = {
            closeButton: true,
            progressBar: true,
            timeOut: 0,
            extendedTimeOut: 0
        };
        toastr.info('Preparing your download...', {timeOut: 3000, progressBar: true});
        axios.get(_url, { params: {batch_id: _batch_id, filename: _filename, is_zip: _is_zip}, responseType: 'json'})
            .then(response => {
                if(response.data.status) {
                    this.get_export(response.data.url);
                } else {
                    monitor_export(_url, _batch_id, _filename, _is_zip);
                }

            }).catch(error => {
                toastr.clear();
                toastr.error('An error occurred while preparing your download.', null, {timeOut: 3000, progressBar: true});
            });
    }

    static get_export(_urls) {
        const triggerDownload = (url) => {
            const link = document.createElement('a');
            link.href = url;
            link.download = '';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        if (Array.isArray(_urls)) {
            _urls.forEach(triggerDownload);
            toastr.clear();
            toastr.success('All downloads have been initiated!', null, {timeOut: 3000, progressBar: true});
        } else {
            triggerDownload(_urls);
            toastr.clear();
            toastr.success('Your download is ready!', null, {timeOut: 3000, progressBar: true});
        }
    }
}